const Colors = {
  red: "#DA634A",
  borderColor: "green",
  appColor: "#39f",
};

export default Colors;
